import React from "react";
import { Row, Badge, Card, CardBody, Button } from "reactstrap";
import "../assets/styles/PackageCard.scss";

const PackageCard = ({
  subjects,
  qualification,
  classMethod,
  targetAudience,
  onClick,
}) => {
  return (
    <Card className="package-card">
      <CardBody>
        <Row className="table_top_row">
          <div
            className="col-4 text-center"
            style={{ borderRight: "2px solid #555" }}
          >
            <span>과정</span>
            <div>{qualification}</div>
          </div>
          <div
            className="col-4 text-center"
            style={{ borderRight: "2px solid #555" }}
          >
            <span>강의 방법</span>
            <div>{classMethod}</div>
          </div>
          <div className="col-4 text-center">
            <span>대상자</span>
            <div>{targetAudience}</div>
          </div>
        </Row>
        <Row
          className="table_middle_row"
          style={{ borderBottom: "2px solid #555", paddingBottom: "1rem" }}
        >
          <div className="col-md-3 col-12">
            <span>과목</span>
          </div>
          <div className="col-md-9 col-12">
            <Row className="subject-badges">
              {subjects
                ? subjects.map((subject) => (
                    <Badge key={subject.id}>{subject.name}</Badge>
                  ))
                : ""}
            </Row>
          </div>
        </Row>
        <Row className="table_middle_row">
          <div className="col-12">
            <div
              style={{ fontSize: "0.9rem", fontWeight: "400", color: "#fff" }}
            >
              <span style={{ color: "#fc0" }}>선생님 배정, 수업 스케줄</span>
              등은 학생에게 <span style={{ color: "#fc0" }}>
                최적화
              </span>되도록{" "}
              <span style={{ color: "#fc0" }}>조율해드립니다.</span>
            </div>
          </div>
        </Row>
        <Row className="table_middle_row">
          <div className="col-12">
            <Button style={{ width: "100%" }} onClick={onClick}>
              수강 신청하기
            </Button>
          </div>
        </Row>
      </CardBody>
    </Card>
  );
};

export default PackageCard;
